<template>

  <!-- Owner home -->
  <page v-if="client.is_owner">
    <owner-sidebar slot="sidebar"/>
    <span slot="header">{{ header }}</span>
  </page>

  <!-- Everyone else home -->
  <page v-else :basic="true">
    <span slot="header">{{ header }}</span>
    <b-tabs card no-fade @input="clearForm">
      <b-tab title="Your Organizations" active>
        <your-organizations/>
      </b-tab>
      <b-tab title="Request Access">
        <request-access ref="requestAccess"/>
      </b-tab>
    </b-tabs>
  </page>

</template>

<script>
import { mapState } from 'vuex'
import ownerSidebar from '../../sidebar/owner'
import page from '../../templates/page'
import requestAccess from './request-access'
import yourOrganizations from './your-organizations'

export default {
  components: {
    ownerSidebar,
    page,
    requestAccess,
    yourOrganizations
  },
  data () {
    return {
      header: 'Home'
    }
  },
  computed: {
    ...mapState('client', {
      client: 'data'
    })
  },
  created () {
    // set the user id for google analytics
    this.$ga.set('userId', this.client.id)
  },
  methods: {
    clearForm (e) {
      if (!this.$refs.requestAccess.saving) {
        this.$refs.requestAccess.resetForm()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.tab-pane {
  margin-top: $spacing-sm;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/index.vue